export enum ShipmentType {
  Collection = 'Recolección',
  CustomerPickup = 'Cliente recoge',
  Courier = 'Paquetera',
  NonStop = 'Directo',
  MultiStop = 'Reparto',
  Portage = 'Porteo',
  PortageMultiStop = 'Porteo con reparto'
}
